import { useEffect, useState } from 'react'

export default function useOrientation() {
    const [isLandscape, setLandscape] = useState(false)
    useEffect(() => {
        const mql = window.matchMedia('(orientation:landscape)');
        if (!mql) return
        function handleOrientation() {
            if (mql.matches) return setLandscape(true)
            else setLandscape(false)
        }
        if (!mql || !mql.addEventListener) return
        mql.addEventListener('change', handleOrientation)
        handleOrientation()
        return () => mql.removeEventListener('change', handleOrientation)
    }, [])
    return isLandscape
}